import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { DevicesService, DOWNLOAD_AGENT_TYPE, NotificationService } from '@nrwl/common-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'download-agent',
  templateUrl: './download.agent.component.html',
  styleUrls: ['./download.agent.component.scss']
})
export class DownloadAgentComponent implements OnInit, OnDestroy {
  @Output() closeAgentDownloadFlyout = new EventEmitter();
  downloadURL = {
    [DOWNLOAD_AGENT_TYPE.WINDOWS]: null,
    [DOWNLOAD_AGENT_TYPE.OVA]: null,
    [DOWNLOAD_AGENT_TYPE.QCOW2]: null,
    [DOWNLOAD_AGENT_TYPE.HARDWARE]: null,
    [DOWNLOAD_AGENT_TYPE.CONFIG_ISO]: null,
    [DOWNLOAD_AGENT_TYPE.CONFIG_FILE]: null
  };

  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(
    private readonly deviceService: DevicesService,
    private readonly notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.getAgentDownloadLink();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  close(): void {
    this.closeAgentDownloadFlyout.emit(false);
  }

  getAgentDownloadLink(): void {
    const firmwareData = this.deviceService.getFirmwareValues();
    firmwareData?.pipe(takeUntil(this.unsubscribe)).subscribe(response => {
      if (response) {
        const links = response.latestFirmwareImages;
        const isoImage = response['agent-image'];
        const confFile = response.cloud_init;
        this.downloadURL[DOWNLOAD_AGENT_TYPE.WINDOWS] = this.changeSecuredLink(
          links?.windows?.image
        );
        this.downloadURL[DOWNLOAD_AGENT_TYPE.OVA] = this.changeSecuredLink(links?.ova?.image);
        this.downloadURL[DOWNLOAD_AGENT_TYPE.QCOW2] = this.changeSecuredLink(links?.qcow2?.image);
        this.downloadURL[DOWNLOAD_AGENT_TYPE.HARDWARE] = this.changeSecuredLink(links?.olhw?.image);
        this.downloadURL[DOWNLOAD_AGENT_TYPE.CONFIG_ISO] = this.changeSecuredLink(isoImage?.image);
        this.downloadURL[DOWNLOAD_AGENT_TYPE.CONFIG_FILE] = this.changeSecuredLink(confFile?.image);
      }
    });
  }

  changeSecuredLink(url: string): string {
    return url?.includes('http') && !url?.includes('https') ? url.replace('http', 'https') : url;
  }

  copyLink(url: string): void {
    if (url && url.length > 0) {
      const successMsg = 'Link copied to clipboard';
      this.notificationService.onSuccess(successMsg);
    }
  }
}
